import React, { useMemo } from "react";

const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

/* Drifting smoke, gold rim light, floating dust motes + film grain */
export default function Atmosphere() {
  const motes = useMemo(() => {
    const count = isMobile ? 16 : 42;
    return Array.from({ length: count }).map((_, i) => ({
      id: i,
      left: Math.random() * 100,
      top: Math.random() * 100,
      size: 1 + Math.random() * 3,
      dur: 8 + Math.random() * 12,
      delay: Math.random() * 10,
      op: 0.25 + Math.random() * 0.45,
    }));
  }, []);

  return (
    <>
      <div className="dust" data-testid="atmosphere-dust" aria-hidden>
        {motes.map((m) => (
          <span
            key={m.id}
            className="mote"
            style={{
              left: `${m.left}%`,
              top: `${m.top}%`,
              width: m.size,
              height: m.size,
              "--o": m.op,
              animation: `motefloat ${m.dur}s ease-in-out ${m.delay}s infinite`,
            }}
          />
        ))}
      </div>

      <div className="fixed inset-0 z-0 pointer-events-none" aria-hidden>
        <div
          className="smoke"
          style={{
            width: "55vw",
            height: "55vw",
            left: "-12vw",
            top: "8vh",
            background:
              "radial-gradient(circle, rgba(60,80,60,0.20), rgba(10,10,10,0) 70%)",
            animation: "drift1 26s ease-in-out infinite",
          }}
        />
        <div
          className="smoke"
          style={{
            width: "50vw",
            height: "50vw",
            right: "-14vw",
            top: "45vh",
            background:
              "radial-gradient(circle, rgba(80,60,20,0.18), rgba(10,10,10,0) 70%)",
            animation: "drift2 32s ease-in-out infinite",
          }}
        />
      </div>

      <div className="grain" aria-hidden />
    </>
  );
}
